import React from "react"
import styled from "@emotion/styled"

import "./layout.css"
import Header from "./headerV2"
import Footer from "./footerV2"
import WhatsAppButton from "./whatsapp-button"

const Container = styled.main`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  margin: 0 auto;
  @media (min-width: 1199px) {
    width: auto;
  }
  @media (min-width: 927px) {
    padding-top: 7%;
  }
`

type Props = {
  children: React.ReactNode
}

const Layout = ({ children }: Props) => (
  <>
    <Header />
    <Container>{children}</Container>
    <Footer />
    <WhatsAppButton />
  </>
)


export default Layout
